import { StorageAdapter } from '../StorageAdapter'

/**
 * In-memory storage. Loses everything on page reload / app restart.
 * Useful for tests and as the default when no persistence is wanted.
 */
export const createMemoryStorage = (): StorageAdapter => {
    const store = new Map<string, string>()
    return {
        name: 'memoryStorage',
        get: key => Promise.resolve(store.get(key) ?? null),
        set: (key, value) => {
            store.set(key, value)
            return Promise.resolve()
        },
        remove: key => {
            store.delete(key)
            return Promise.resolve()
        },
    }
}

export const memoryStorage = createMemoryStorage()
